<template>
  <div class="help-center">
    <el-tabs v-model="tab">
      <el-tab-pane label="业务流程" name="flow">
        <div class="biz-flow">
          <div class="intro">
            <h2>系统业务流程</h2>
            <p>从线索进线到客户经营、商机成交、合同回款，按下面主线推进即可。详细逐步操作见「操作手册」页签。</p>
          </div>

          <section class="flow-block">
            <div class="flow-title">一、主流程（销售日常）</div>
            <div class="flow-row">
              <div class="node primary">
                <div class="n-step">1</div>
                <div class="n-name">线索进线</div>
                <div class="n-desc">录入线索<br/>分配 / 领取<br/>跟进培育</div>
              </div>
              <div class="arrow">→</div>
              <div class="node primary">
                <div class="n-step">2</div>
                <div class="n-name">转客户 &amp; 商机</div>
                <div class="n-desc">确认意向后转化<br/>建客户与联系人<br/>推进商机阶段</div>
              </div>
              <div class="arrow">→</div>
              <div class="node primary">
                <div class="n-step">3</div>
                <div class="n-name">报价审批</div>
                <div class="n-desc">产品报价<br/>折扣审批<br/>通过后签合同</div>
              </div>
              <div class="arrow">→</div>
              <div class="node primary">
                <div class="n-step">4</div>
                <div class="n-name">合同 &amp; 回款</div>
                <div class="n-desc">合同履约<br/>回款计划<br/>开票跟踪</div>
              </div>
              <div class="arrow">→</div>
              <div class="node primary">
                <div class="n-step">5</div>
                <div class="n-name">客户经营</div>
                <div class="n-desc">续跟提醒<br/>公海回收<br/>复购与续约</div>
              </div>
            </div>
          </section>

          <section class="flow-block">
            <div class="flow-title">二、两端怎么配合</div>
            <div class="roles">
              <div class="role-card">
                <div class="role-head pc">PC 管理端</div>
                <ul>
                  <li>组织权限、产品、扩展字段</li>
                  <li>线索 / 客户 / 商机全流程</li>
                  <li>报价、合同、回款、审批</li>
                  <li>套餐订阅、咨询工单</li>
                </ul>
              </div>
              <div class="role-card">
                <div class="role-head app">销售 App</div>
                <ul>
                  <li>工作台看待办与指标</li>
                  <li>线索跟进、领取公海</li>
                  <li>查看客户与转商机</li>
                  <li>外勤场景快速记录</li>
                </ul>
              </div>
              <div class="role-card">
                <div class="role-head mp">角色分工</div>
                <ul>
                  <li>销售：跟线索、推商机</li>
                  <li>销售主管：审批、看部门数据</li>
                  <li>客服：客户服务与提醒</li>
                  <li>管理员：组织与套餐</li>
                </ul>
              </div>
            </div>
            <div class="role-flow">
              <span class="chip pc">PC 配置 &amp; 签单</span>
              <span class="arr">→</span>
              <span class="chip app">App 外勤跟进</span>
              <span class="arr">→</span>
              <span class="chip mp">主管审批把关</span>
              <span class="arr">→</span>
              <span class="chip pc">回款与续约</span>
            </div>
          </section>

          <section class="flow-block">
            <div class="flow-title">三、公海与成交细流</div>
            <div class="sub-flows">
              <div class="sub-flow">
                <div class="sub-label">公海</div>
                <div class="sub-steps">
                  <span>超时未跟进</span>
                  <i>→</i>
                  <span>放入公海</span>
                  <i>→</i>
                  <span>他人领取</span>
                  <i>→</i>
                  <span>继续跟进</span>
                </div>
              </div>
              <div class="sub-flow">
                <div class="sub-label">成交</div>
                <div class="sub-steps">
                  <span>商机推进</span>
                  <i>→</i>
                  <span>报价审批</span>
                  <i>→</i>
                  <span>合同生效</span>
                  <i>→</i>
                  <span>回款 / 开票</span>
                </div>
              </div>
            </div>
          </section>

          <section class="flow-block last">
            <div class="flow-title">四、对象怎么区分</div>
            <div class="flow-row compact">
              <div class="node soft">
                <div class="n-name">线索</div>
                <div class="n-desc">尚未确认成单的意向</div>
              </div>
              <div class="arrow">→</div>
              <div class="node soft">
                <div class="n-name">客户</div>
                <div class="n-desc">已建立生意关系的主体</div>
              </div>
              <div class="arrow">→</div>
              <div class="node soft">
                <div class="n-name">商机</div>
                <div class="n-desc">正在推进的一单生意</div>
              </div>
              <div class="arrow">→</div>
              <div class="node soft">
                <div class="n-name">合同 / 回款</div>
                <div class="n-desc">成交后的履约与收款</div>
              </div>
            </div>
            <p class="hint">线索、客户、商机是不同对象。转化后线索标记为已转化，商机单独推进阶段，不要混成同一张表使用。</p>
          </section>
        </div>
      </el-tab-pane>
      <el-tab-pane label="操作手册" name="manual">
        <user-manual />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import UserManual from './UserManual.vue'

export default {
  name: 'HelpBizFlow',
  components: { UserManual },
  data() {
    return {
      tab: 'flow'
    }
  },
  created() {
    const t = this.$route.query.tab
    if (t === 'manual' || t === 'flow') this.tab = t
  }
}
</script>

<style scoped>
.help-center {
  max-width: 1100px;
}
.help-center >>> .el-tabs__header {
  margin-bottom: 16px;
}
.biz-flow {
  max-width: 1100px;
}

.intro {
  margin-bottom: 20px;
}
.intro h2 {
  margin: 0 0 6px;
  font-size: 20px;
  color: #0f172a;
}
.intro p {
  margin: 0;
  color: #64748b;
  font-size: 14px;
}

.flow-block {
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 18px 20px 20px;
  margin-bottom: 16px;
}
.flow-block.last {
  margin-bottom: 0;
}
.flow-title {
  font-size: 15px;
  font-weight: 600;
  color: #0f172a;
  margin-bottom: 14px;
}

.flow-row {
  display: flex;
  align-items: stretch;
  flex-wrap: wrap;
  gap: 8px;
}
.flow-row.compact .node {
  min-width: 140px;
  flex: 1;
}

.node {
  flex: 1;
  min-width: 150px;
  border-radius: 10px;
  padding: 14px 12px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
}
.node.primary {
  background: linear-gradient(180deg, #eff6ff 0%, #f8fafc 100%);
  border-color: #bfdbfe;
}
.node.soft {
  background: #f1f5f9;
  text-align: center;
  padding: 16px 10px;
}
.n-step {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: #0f766e;
  color: #fff;
  font-size: 12px;
  font-weight: 700;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 8px;
}
.n-name {
  font-weight: 600;
  color: #0f172a;
  margin-bottom: 6px;
  font-size: 14px;
}
.n-desc {
  font-size: 12px;
  color: #64748b;
  line-height: 1.5;
}
.arrow {
  display: flex;
  align-items: center;
  color: #94a3b8;
  font-size: 18px;
  font-weight: 600;
  padding: 0 2px;
}

.roles {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
}
.role-card {
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  overflow: hidden;
  background: #fafbfc;
}
.role-head {
  padding: 10px 14px;
  font-weight: 600;
  font-size: 14px;
  color: #fff;
}
.role-head.pc { background: #0f766e; }
.role-head.app { background: #2563eb; }
.role-head.mp { background: #7c3aed; }
.role-card ul {
  margin: 0;
  padding: 12px 14px 14px 30px;
  color: #475569;
  font-size: 13px;
  line-height: 1.7;
}
.role-flow {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 14px;
  padding-top: 14px;
  border-top: 1px dashed #e2e8f0;
}
.chip {
  display: inline-block;
  padding: 6px 12px;
  border-radius: 999px;
  font-size: 13px;
  font-weight: 500;
  color: #fff;
}
.chip.pc { background: #0f766e; }
.chip.app { background: #2563eb; }
.chip.mp { background: #7c3aed; }
.arr { color: #94a3b8; font-weight: 600; }

.sub-flows {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.sub-flow {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}
.sub-label {
  flex: 0 0 52px;
  height: 28px;
  line-height: 28px;
  text-align: center;
  border-radius: 6px;
  background: #0f172a;
  color: #fff;
  font-size: 12px;
  font-weight: 600;
}
.sub-steps {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
  flex: 1;
}
.sub-steps span {
  background: #f1f5f9;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  padding: 6px 10px;
  font-size: 13px;
  color: #334155;
}
.sub-steps i {
  font-style: normal;
  color: #94a3b8;
  font-weight: 600;
}

.hint {
  margin: 12px 0 0;
  font-size: 12px;
  color: #94a3b8;
}

@media (max-width: 900px) {
  .roles { grid-template-columns: 1fr; }
  .arrow { display: none; }
  .node { min-width: 100%; }
}
</style>
